var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-dialog",
    {
      directives: [{ name: "dialogDrag", rawName: "v-dialogDrag" }],
      attrs: {
        title: _vm.title,
        "close-on-click-modal": false,
        visible: _vm.visible,
      },
      on: {
        "update:visible": function ($event) {
          _vm.visible = $event
        },
      },
    },
    [
      _c(
        "el-form",
        {
          directives: [
            {
              name: "loading",
              rawName: "v-loading",
              value: _vm.loading,
              expression: "loading",
            },
          ],
          ref: "inputForm",
          class: _vm.method === "view" ? "readonly" : "",
          attrs: {
            size: "small",
            model: _vm.inputForm,
            rules: _vm.dataRule,
            "label-width": "80px",
            disabled: _vm.method === "view",
          },
          nativeOn: {
            keyup: function ($event) {
              if (
                !$event.type.indexOf("key") &&
                _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
              ) {
                return null
              }
              return _vm.doSubmit()
            },
            submit: function ($event) {
              $event.preventDefault()
            },
          },
        },
        [
          _c(
            "el-row",
            { attrs: { gutter: 15 } },
            [
              _c(
                "el-col",
                { attrs: { span: 12 } },
                [
                  _c(
                    "el-form-item",
                    { attrs: { label: "上级区域", prop: "parent.id" } },
                    [
                      _vm.visible
                        ? _c("SelectTree", {
                            ref: "parentTree",
                            attrs: {
                              props: {
                                value: "id", // ID字段名
                                label: "name", // 显示名称
                                children: "children", // 子级字段名
                              },
                              url:
                                "/sys/area/treeData?extId=" + _vm.inputForm.id,
                              value: _vm.inputForm.parent.id,
                              clearable: true,
                              accordion: true,
                            },
                            on: {
                              getValue: function (value) {
                                _vm.inputForm.parent.id = value
                              },
                            },
                          })
                        : _vm._e(),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-col",
                { attrs: { span: 12 } },
                [
                  _c(
                    "el-form-item",
                    { attrs: { label: "区域名称", prop: "name" } },
                    [
                      _c("el-input", {
                        attrs: { maxlength: "50", placeholder: "区域名称" },
                        model: {
                          value: _vm.inputForm.name,
                          callback: function ($$v) {
                            _vm.$set(_vm.inputForm, "name", $$v)
                          },
                          expression: "inputForm.name",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-col",
                { attrs: { span: 12 } },
                [
                  _c(
                    "el-form-item",
                    { attrs: { label: "区域编码", prop: "code" } },
                    [
                      _c("el-input", {
                        attrs: { maxlength: "50", placeholder: "区域编码" },
                        model: {
                          value: _vm.inputForm.code,
                          callback: function ($$v) {
                            _vm.$set(_vm.inputForm, "code", $$v)
                          },
                          expression: "inputForm.code",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-col",
                { attrs: { span: 12 } },
                [
                  _c(
                    "el-form-item",
                    { attrs: { label: "区域类型", prop: "type" } },
                    [
                      _c(
                        "el-select",
                        {
                          staticStyle: { width: "100%" },
                          attrs: { placeholder: "请选择" },
                          model: {
                            value: _vm.inputForm.type,
                            callback: function ($$v) {
                              _vm.$set(_vm.inputForm, "type", $$v)
                            },
                            expression: "inputForm.type",
                          },
                        },
                        _vm._l(
                          _vm.$dictUtils.getDictList("sys_area_type"),
                          function (item) {
                            return _c("el-option", {
                              key: item.value,
                              attrs: { label: item.label, value: item.value },
                            })
                          }
                        ),
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-col",
                { attrs: { span: 12 } },
                [
                  _c(
                    "el-form-item",
                    { attrs: { label: "排序号", prop: "sort" } },
                    [
                      _c("el-input-number", {
                        staticStyle: { width: "100%" },
                        attrs: { step: 30 },
                        model: {
                          value: _vm.inputForm.sort,
                          callback: function ($$v) {
                            _vm.$set(_vm.inputForm, "sort", $$v)
                          },
                          expression: "inputForm.sort",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-col",
                { attrs: { span: 12 } },
                [
                  _c(
                    "el-form-item",
                    { attrs: { label: "备注", prop: "remarks" } },
                    [
                      _c("el-input", {
                        attrs: {
                          maxlength: "200",
                          type: "textarea",
                          rows: 2,
                          placeholder: "备注",
                        },
                        model: {
                          value: _vm.inputForm.remarks,
                          callback: function ($$v) {
                            _vm.$set(_vm.inputForm, "remarks", $$v)
                          },
                          expression: "inputForm.remarks",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "span",
        {
          staticClass: "dialog-footer",
          attrs: { slot: "footer" },
          slot: "footer",
        },
        [
          _c(
            "el-button",
            {
              attrs: { size: "small", icon: "el-icon-circle-close" },
              on: {
                click: function ($event) {
                  _vm.visible = false
                },
              },
            },
            [_vm._v("关闭")]
          ),
          _vm.method != "view"
            ? _c(
                "el-button",
                {
                  directives: [
                    { name: "noMoreClick", rawName: "v-noMoreClick" },
                  ],
                  attrs: {
                    size: "small",
                    type: "primary",
                    icon: "el-icon-circle-check",
                  },
                  on: {
                    click: function ($event) {
                      return _vm.doSubmit()
                    },
                  },
                },
                [_vm._v("确定")]
              )
            : _vm._e(),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }